import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import FrontMainLandFreight from '../entities/front-mainlandfreight'
import appconst from '@/lib/appconst';


interface FrontMainLandFreightState extends ListState<FrontMainLandFreight> {
    total: any;
    FrontMainLandFreightInfo: FrontMainLandFreight,
}

class FrontMainLandFreightMutations extends ListMutations<FrontMainLandFreight>{

}
class FrontMainLandFreightInfo extends ListModule<FrontMainLandFreightState, any, FrontMainLandFreight>{
    state = {
        totalCount: 0,
        total: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<FrontMainLandFreight>(),
        loading: false,


    }
    actions = {
        async getAll(context: ActionContext<FrontMainLandFreightState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontMainLandFreight/GetFrontMainLandFreightList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<FrontMainLandFreight>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getFreightModel(context: ActionContext<FrontMainLandFreightState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontMainLandFreight/GetFreightModel', payload.data);
            return rep.data.result;
        },
    };
}

const frontmainlandfeightinfo = new FrontMainLandFreightInfo();
export default frontmainlandfeightinfo;